// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d2ece3fc","453":"7942bd8d","455":"560ced05","977":"09a5a7f3"}[chunkId] + ".chunk.js";
};